export default "__VITE_ASSET__DeFnxSpJ__"